// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"debd99ad","226":"ac30fe8e","451":"52e9044d","453":"cb03f542","526":"7b390088","724":"7b04e68c","732":"080fe636","770":"339abcbf"}[chunkId] + ".chunk.js";
};